/**
 * dictionarySlice — manages the word dictionary state.
 */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Full word list (uppercase Turkish)
  words: [],
  // Loading state
  loading: false,
  // Whether dictionary is loaded
  loaded: false,
  // Error message
  error: null,
};

const dictionarySlice = createSlice({
  name: 'dictionary',
  initialState,
  reducers: {
    /**
     * Request to load the dictionary (triggers saga).
     */
    loadDictionary(state) {
      state.loading = true;
      state.error = null;
    },

    /**
     * Dictionary loaded successfully.
     */
    loadDictionarySuccess(state, action) {
      state.words = action.payload;
      state.loading = false;
      state.loaded = true;
    },

    /**
     * Dictionary loading failed.
     */
    loadDictionaryFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { loadDictionary, loadDictionarySuccess, loadDictionaryFailure } =
  dictionarySlice.actions;

export default dictionarySlice.reducer;
